import { LockIcon, RepeatClockIcon, UnlockIcon } from '@chakra-ui/icons'
import { Box, Flex, Grid, GridItem, HStack, IconButton, Spinner, StackDivider, Tag, TagLabel, TagLeftIcon, Text, Tooltip, VStack } from '@chakra-ui/react'
import { useDoorData } from './context/DoorContext';

function DoorItem() {

  const { openDoor, openLongDoor, closeDoor, data, loading, getDoorStatusBadge } = useDoorData()

  return (
    
    <Grid mx={'5vw'} 
  //  gridRow={'3 / 4'}
     gap={'5%'} templateColumns='repeat( auto-fill, minmax(40rem, 1fr) )'>
    {loading !== true ?
    data.map((door, index) => {
      const doorStatus = getDoorStatusBadge(door.doorStatus);
console.log("door=======")
console.log(door)
console.log("index=======")
console.log( index)
     return  <GridItem key={index} >
      <HStack position={'relative'} overflow={'hidden'} bg={'#f5f5f5'} borderRadius={'1rem'} justifyContent={'space-between'}>
        <HStack >
        <Tooltip hasArrow label={doorStatus.text} aria-label='Atrakinti keliom sekundėm'>
        <Box p={'1.3rem'}  bg={doorStatus.bgColor}>
          <HStack divider={<StackDivider borderColor='gray.200' />}>
            <Text color={'#fff'}>{door.doorID}</Text>
            {<Text as={doorStatus.icon} color={'#fff'}>{door.doorID}</Text>}
            </HStack>
        </Box>
        </Tooltip>
      <Text color={'#1A202C'} fontWeight={'500'} textTransform={'uppercase'} fontSize={'1.2rem'} pl={'1rem'}>{door.doorName}</Text>
        {/* <Tag size={'lg'} variant='solid' colorScheme={doorStatus.color}>
      <TagLeftIcon  as={doorStatus.icon} />
      <TagLabel>{doorStatus.text}</TagLabel>
    </Tag> */}
        </HStack>
        <HStack spacing={'0'} >
        <Tooltip label="Atrakinti keliom sekundėm" aria-label='Atrakinti keliom sekundėm'>
          <IconButton
            size={'xl'}
            borderRadius={'0'}
            p={'1.6rem'}
            bg='green.500'
            color={'#fff'}
            _hover={{bg:'green.600'}}
            aria-label='Atrakinti'
            onClick={() => {openDoor(door.doorID)}}
            icon={<UnlockIcon />}
          />
          </Tooltip>
          <Tooltip label="Užrakinti duris" aria-label='Užrakinti duris'>
      <IconButton
        margin={'0!important'}
       size={'xl'}
       borderRadius={'0'}
       p={'1.6rem'}
       bg='red.500'
            color={'#fff'}
            _hover={{bg:'red.600'}}
        aria-label='Užrakinti'
        onClick={() => {closeDoor(door.doorID)}}
        icon={<LockIcon />}
      />
      </Tooltip>
      <Tooltip label="Palikti atrakintą visam laikui" aria-label='Palikti atrakintą visam laikui'>
      <IconButton
      margin={'0!important'}
       size={'xl'}
       borderRadius={'0'}
       p={'1.6rem'}
       bg='orange.500'
       color={'#fff'}
       _hover={{bg:'orange.600'}}
        aria-label='Atrakinti ilgam'
        onClick={() => {openLongDoor(door.doorID)}}
        icon={<RepeatClockIcon />}
        />
        </Tooltip>
    </HStack>
</HStack>


    </GridItem>
    }) : <Flex w={'90vw'} alignItems={'center'} justifyContent={'center'}><Spinner
    thickness='4px'
    speed='0.65s'
    emptyColor='gray.200'
    color='green.500'
    size='xl'
  /></Flex> }
    
    </Grid>
           
  
  )
}

export default DoorItem